import { MIME_TYPES } from '@shared/components';
import { z } from 'zod';

export const MAX_FILE_SIZE_IN_MB = 20; // 20 MB
export const ALLOWED_FILE_TYPES: string[] = [MIME_TYPES.csv, MIME_TYPES.xlsx, MIME_TYPES.xls];

const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1024 * 1024;

export const ImportExamineeAnswersSchema = z.object({
  file: z
    .instanceof(File, {
      message: 'กรุณาแนบไฟล์อัปโหลด',
    })
    .refine(
      (file) => ALLOWED_FILE_TYPES.includes(file.type),
      'รูปแบบไฟล์ไม่ถูกต้อง กรุณาอัปโหลดไฟล์ .csv หรือ .xlsx หรือ .xls เท่านั้น',
    )
    .refine(
      (file) => file.size < MAX_FILE_SIZE_IN_BYTES,
      `ขนาดไฟล์เกิน ${MAX_FILE_SIZE_IN_MB} MB ไม่สามารถอัปโหลดได้.`,
    ),
});

export type ImportExamineeAnswersFormType = z.infer<typeof ImportExamineeAnswersSchema>;
